import { Highlightable } from '@angular/cdk/a11y';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
} from '@angular/core';

import {
  AutocompleteOptionClickEvent,
  AutocompleteOptionHoverEvent,
  IAutocompleteOption,
} from './autocomplete.model';

@Component({
  selector: 'nibtravel-autocomplete-option',
  templateUrl: './autocomplete-option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteOptionComponent
  implements IAutocompleteOption, Highlightable {
  disabled?: boolean | undefined;
  optionHovered = new EventEmitter<AutocompleteOptionHoverEvent>();
  optionClicked = new EventEmitter<AutocompleteOptionClickEvent>();

  @Input() text = '';
  @Input() value = '';
  @Input() index = -1;
  @Input() id = '';

  @HostBinding('class') class = 'autocomplete-option';
  @HostBinding('class.selected') isOptionSelected = false;

  @HostListener('mouseover', ['$event'])
  onOptionHover(): void {
    this.optionHovered.emit({ option: this.cloneOption() });
  }

  @HostListener('click', ['$event'])
  onOptionClick(): void {
    this.optionClicked.emit({ option: this.cloneOption() });
  }

  setActiveStyles(): void {
    this.isOptionSelected = true;
  }

  setInactiveStyles(): void {
    this.isOptionSelected = false;
  }

  private cloneOption(): IAutocompleteOption {
    return {
      index: this.index,
      value: this.value,
      id: this.id,
      text: this.text,
    };
  }
}
